<template>
  <div class="grade-analysis">
    <!-- 成绩趋势图 -->
    <div class="trend-chart chart-item">
      <div class="chart-header">
        <span class="chart-title">成绩趋势</span>
      </div>
      <Echart :options="trendOptions" height="180px" />
    </div>

    <!-- 各科成绩分布 -->
    <div class="distribution-chart chart-item">
      <div class="chart-header">
        <span class="chart-title">各科成绩分布</span>
      </div>
      <Echart :options="distributionOptions" height="180px" />
    </div>

    <!-- 排名信息 -->
    <div class="ranking-info chart-item">
      <div class="chart-header">
        <span class="chart-title">排名信息</span>
      </div>
      <div class="rank-cards">
        <div class="rank-card" v-for="(item, index) in rankingData" :key="index">
          <div class="rank-value">{{ item.number.number[0] }}</div>
          <div class="rank-label">{{ item.text }}</div>
          <div class="rank-trend" :class="item.trend > 0 ? 'up' : 'down'">
            {{ Math.abs(item.trend) }}
            <i class="trend-icon" :class="item.trend > 0 ? 'up-icon' : 'down-icon'"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart'

export default {
  data() {
    return {
      trendOptions: {},
      distributionOptions: {},
      rankingData: [
        {
          number: { number: [6], toFixed: 0 },
          text: '班级排名',
          trend: -2
        },
        {
          number: { number: [20], toFixed: 0 },
          text: '专业排名',
          trend: 3
        },
        {
          number: { number: [85], toFixed: 0 },
          text: '平均分',
          trend: 5
        }
      ]
    }
  },
  components: {
    Echart
  },
  mounted() {
    this.initCharts()
  },
  methods: {
    initCharts() {
      // 成绩趋势图配置
      this.trendOptions = {
        grid: {
          top: '15%',
          right: '5%',
          bottom: '12%',
          left: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['2023-1', '2023-2', '2024-1'],
          axisLine: {
            lineStyle: { color: 'rgba(255,255,255,0.2)' }
          },
          axisLabel: { color: '#fff' }
        },
        yAxis: {
          type: 'value',
          min: 60,
          max: 100,
          splitLine: {
            lineStyle: { color: 'rgba(255,255,255,0.1)' }
          },
          axisLine: {
            lineStyle: { color: 'rgba(255,255,255,0.2)' }
          },
          axisLabel: { color: '#fff' }
        },
        series: [
          {
            data: [82, 85, 83],
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              color: '#37a2da'
            },
            itemStyle: {
              color: '#37a2da',
              borderWidth: 2,
              borderColor: '#fff'
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(55,162,218,0.5)' },
                { offset: 1, color: 'rgba(55,162,218,0.1)' }
              ])
            }
          }
        ]
      }

      // 各科成绩分布图配置
      this.distributionOptions = {
        grid: {
          top: '15%',
          right: '5%',
          bottom: '12%',
          left: '5%',
          containLabel: true
        },
        legend: {
          data: ['平时成绩', '期中成绩', '期末成绩'],
          textStyle: { color: '#fff' },
          top: 0
        },
        xAxis: {
          type: 'category',
          data: ['数学', '英语', '物理', '化学'],
          axisLine: {
            lineStyle: { color: 'rgba(255,255,255,0.2)' }
          },
          axisLabel: {
            color: '#fff',
            interval: 0,
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 100,
          splitLine: {
            lineStyle: { color: 'rgba(255,255,255,0.1)' }
          },
          axisLine: {
            lineStyle: { color: 'rgba(255,255,255,0.2)' }
          },
          axisLabel: { color: '#fff' }
        },
        series: [
          {
            name: '平时成绩',
            type: 'bar',
            stack: 'total',
            barWidth: '20%',
            data: [85, 82, 88, 90],
            itemStyle: { color: '#37a2da' }
          },
          {
            name: '期中成绩',
            type: 'bar',
            stack: 'total',
            data: [80, 85, 82, 86],
            itemStyle: { color: '#67e0e3' }
          },
          {
            name: '期末成绩',
            type: 'bar',
            stack: 'total',
            data: [88, 83, 85, 89],
            itemStyle: { color: '#ffdb5c' }
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.grade-analysis {
  padding: 10px;
  height: 100%;
  display: grid;
  grid-template-rows: auto auto auto;
  gap: 15px;

  .chart-item {
    background: rgba(6, 30, 93, 0.5);
    border-radius: 4px;
    padding: 10px;
    backdrop-filter: blur(4px);
    box-shadow: 0 0 10px rgba(0,0,0,0.2);

    .chart-header {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .chart-title {
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 16px;
          background: #37a2da;
          margin-right: 8px;
          vertical-align: middle;
          border-radius: 2px;
        }
      }
    }
  }

  .rank-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    padding: 10px;

    .rank-card {
      background: rgba(6, 30, 93, 0.7);
      border-radius: 8px;
      padding: 15px;
      text-align: center;

      .rank-value {
        font-size: 24px;
        color: #37a2da;
        font-weight: bold;
        margin-bottom: 5px;
      }

      .rank-label {
        color: #fff;
        font-size: 14px;
        margin-bottom: 5px;
      }

      .rank-trend {
        font-size: 12px;
        &.up {
          color: #67e0e3;
        }
        &.down {
          color: #ff6b6b;
        }

        .trend-icon {
          display: inline-block;
          width: 0;
          height: 0;
          margin-left: 4px;
          &.up-icon {
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-bottom: 6px solid #67e0e3;
          }
          &.down-icon {
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 6px solid #ff6b6b;
          }
        }
      }
    }
  }
}
</style>